import { combineReducers } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { fork } from "redux-saga/effects";
import { teamsReducer, watchLoadTeamsRequestSaga } from "./teams";
import { AvailableUsersState } from "./types";
import { usersReducer } from "./users/reducers";
import { watchAvailableUsersRequest, watchInvitedUsers } from "./users/sagas";

const availableUsersReducer = combineReducers<AvailableUsersState["availableUsers"]>({
    teams: teamsReducer,
    users: usersReducer,
});

function* availableUsersRootSaga() {
    yield fork(watchLoadTeamsRequestSaga);
    yield fork(watchAvailableUsersRequest);
    yield fork(watchInvitedUsers);
}

export const getAvailableUsersModule = (): ISagaModule<AvailableUsersState> => ({
    id: "availableUsers",
    reducerMap: {
        availableUsers: availableUsersReducer,
    },
    sagas: [availableUsersRootSaga],
});
